exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".label-rule[data-v-03ac8ea3]{display:inline-block;vertical-align:top}.yxt-dimension-label-select[data-v-03ac8ea3]{width:114px}.w124[data-v-03ac8ea3]{width:124px}.w216[data-v-03ac8ea3]{width:216px}\n", ""]);

